export default "__VITE_ASSET___hhHw_Q2__"